// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProductionLine.css */

/* استایل کانتینر کلی */
.production-line-container {
  padding: 20px;
  direction: rtl; /* اگر نیاز به راست‌به‌چپ دارید */
  font-family: 'IRANSans', sans-serif;
}

/* بخش‌های مختلف با کادر جداگانه */
.section-control {
  margin-top: 30px;
  border: 2px dashed #aaa;
  padding: 20px;
  border-radius: 10px;
}

/* جعبه هر کنترل تگ */
.box {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
  min-width: 120px; /* حداقل عرض باکس */
  text-align: center;
}

/* برای نمایش کنترل‌ها در یک ردیف */
.grid {
  display: flex;
  flex-direction: row;  /* نمایش افقی */
  gap: 20px;            /* فاصله بین آیتم‌ها */
  flex-wrap: wrap;      /* در صورت کمبود فضا به سطر بعد بروند */
  justify-content: center;  /* وسط‌چین کردن آیتم‌ها در محور افقی */
  align-items: center;      /* وسط‌چین عمودی */
}

/* گروه دکمه‌ها */
.button-group {
  display: flex;
  gap: 10px;       /* فاصله افقی بین دکمه‌ها */
  justify-content: center;
  margin-top: 10px; /* فاصله از بالای بخش وضعیت */
}

/* در صورت نیاز به استایل کلی برای دکمه‌ها */
.button-group button {
  padding: 8px 16px;
  font-weight: bold;
  cursor: pointer;
  border: 1px solid #007bff;
  border-radius: 5px;
  background: #007bff;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProductionLine.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,uBAAuB;AACvB;EACE,aAAa;EACb,cAAc,EAAE,iCAAiC;EACjD,mCAAmC;AACrC;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB,EAAE,mBAAmB;EACrC,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB,GAAG,eAAe;EACrC,SAAS,aAAa,sBAAsB;EAC5C,eAAe,OAAO,uCAAuC;EAC7D,uBAAuB,GAAG,sCAAsC;EAChE,mBAAmB,OAAO,kBAAkB;AAC9C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS,QAAQ,2BAA2B;EAC5C,uBAAuB;EACvB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["/* ProductionLine.css */\n\n/* استایل کانتینر کلی */\n.production-line-container {\n  padding: 20px;\n  direction: rtl; /* اگر نیاز به راست‌به‌چپ دارید */\n  font-family: 'IRANSans', sans-serif;\n}\n\n/* بخش‌های مختلف با کادر جداگانه */\n.section-control {\n  margin-top: 30px;\n  border: 2px dashed #aaa;\n  padding: 20px;\n  border-radius: 10px;\n}\n\n/* جعبه هر کنترل تگ */\n.box {\n  background: #f9f9f9;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 0 5px rgba(0,0,0,0.1);\n  min-width: 120px; /* حداقل عرض باکس */\n  text-align: center;\n}\n\n/* برای نمایش کنترل‌ها در یک ردیف */\n.grid {\n  display: flex;\n  flex-direction: row;  /* نمایش افقی */\n  gap: 20px;            /* فاصله بین آیتم‌ها */\n  flex-wrap: wrap;      /* در صورت کمبود فضا به سطر بعد بروند */\n  justify-content: center;  /* وسط‌چین کردن آیتم‌ها در محور افقی */\n  align-items: center;      /* وسط‌چین عمودی */\n}\n\n/* گروه دکمه‌ها */\n.button-group {\n  display: flex;\n  gap: 10px;       /* فاصله افقی بین دکمه‌ها */\n  justify-content: center;\n  margin-top: 10px; /* فاصله از بالای بخش وضعیت */\n}\n\n/* در صورت نیاز به استایل کلی برای دکمه‌ها */\n.button-group button {\n  padding: 8px 16px;\n  font-weight: bold;\n  cursor: pointer;\n  border: 1px solid #007bff;\n  border-radius: 5px;\n  background: #007bff;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
